import { CARD_TYPE } from '../constant/CardType'
import CardView from '../game/CardView'

/**
 * CardModelクラス
 */
class CardModel {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //カードタイプ
  public type: CARD_TYPE

  //カード番号
  public number: number

  //VIEW
  private _view: CardView
  public get view(): CardView {
    if (!this._view) this._view = new CardView(this)
    return this._view
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	CardModel
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(t: CARD_TYPE, n: number) {
    this.type = t
    this.number = n
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default CardModel
